/**
 * Who an inbound caller is — iceberger-back's lead-by-phone lookup, and moving
 * the ringing/open inbound call to another lead that shares the caller's number.
 */
import axios from "@utils/axios-instance";
import type { TLeadsByPhoneResponse } from "@/models/leads.model";

/** Every company lead whose phone matches `e164`, best first (same order the inbound route picks). */
export const getLeadsByPhone = async (e164: string, limit?: number): Promise<TLeadsByPhoneResponse> => {
  const response = await axios.get("/lead/by-phone", { params: { e164, ...(limit ? { limit } : {}) } });
  return response.data;
};

/** Give the agent's own open inbound call to `leadId` (must match the caller's number). */
export const reassignInboundCallLead = async (
  sessionName: string,
  leadId: number,
): Promise<{ callId: number; leadId: number }> => {
  const response = await axios.patch(
    `/call/by-session-name/${encodeURIComponent(sessionName)}/lead`,
    { leadId },
  );
  return response.data;
};
